import Swiper from 'swiper/dist/js/swiper.js';

export default {
  init() {
    jQuery(window).on('load', function() {
      jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 150) {
          jQuery(".nav-produits").addClass('active');
        } else {
          jQuery(".nav-produits").removeClass('active');
        }
      });
      /* Slider */
      if(jQuery(".produits-slider .swiper-slide:not(.swiper-slide-duplicate)").length > 1) {
          new Swiper('.produits-slider', {
          autoplay: { delay: 5000 },
          spaceBetween: 100,
          speed: 1000,
          autoHeight: false,
          parallax: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          //effect: 'fade',
          centeredSlides: true,
          loop: true,
          slidesPerView: 1,
          setWrapperSize: true,
          pagination: { el: '.swiper-pagination', clickable: true },
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/single-produits.js